import { render, staticRenderFns } from "./ConfirmedPosts.vue?vue&type=template&id=68d92f20&"
import script from "./ConfirmedPosts.vue?vue&type=script&lang=js&"
export * from "./ConfirmedPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports